import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { useStateContext } from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import { postRequest } from "../../../constants/api";
import { handleLogout } from "../../../constants/logoutHelper";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import { Box, Button, Snackbar, Alert } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import useScreenWidth from "../../../hooks/useScreenWidth";

const UbahSetting = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [namaPerusahaan, setNamaPerusahaan] = useState("");
  const [alamatPerusahaan, setAlamatPerusahaan] = useState("");
  const [kotaPerusahaan, setKotaPerusahaan] = useState("");
  const [kabupatenPerusahaan, setKabupatenPerusahaan] = useState("");
  const [provinsiPerusahaan, setProvinsiPerusahaan] = useState("");
  const [teleponPerusahaan, setTeleponPerusahaan] = useState("");
  const [direkturUtama, setDirekturUtama] = useState("");

  // COA
  const [coaKasKasir, setCoaKasKasir] = useState("");
  const [coaHutangPembelianBarang, setCoaHutangPembelianBarang] = useState("");
  const [coaPersediaan, setCoaPersediaan] = useState("");
  const [coaPiutangPenjualan, setCoaPiutangPenjualan] = useState("");
  const [coaPendapatanPenjualan, setCoaPendapatanPenjualan] = useState("");
  const [coaHargaPokokPenjualan, setCoaHargaPokokPenjualan] = useState("");
  const [coaPendapatanLainLain, setCoaPendapatanLainLain] = useState("");
  const [coaRugiSelisihOpname, setCoaRugiSelisihOpname] = useState("");
  const [labaRugiPeriodeBerjalan, setLabaRugiPeriodeBerjalan] = useState("");
  const [accountPembalance, setAccountPembalance] = useState("");

  // Group COA
  const [kodeGroupPendapatan, setKodeGroupPendapatan] = useState("");
  const [kodeGroupBiayaAtasPendapatan, setKodeGroupBiayaAtasPendapatan] =
    useState("");
  const [kodeGroupPengeluaranOperasional, setKodeGroupPengeluaranOperasional] =
    useState("");
  const [kodeGroupPendapatanLainLain, setKodeGroupPendapatanLainLain] =
    useState("");
  const [kodeGroupBiayaLainLain, setKodeGroupBiayaLainLain] = useState("");

  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    getSettingById();
  }, []);

  const getSettingById = async () => {
    setLoading(true);
    const response = await postRequest(
      `/settings/${id}`,
      {},
      navigate,
      dispatch
    );
    setNamaPerusahaan(response.data.namaPerusahaan);
    setAlamatPerusahaan(response.data.alamatPerusahaan);
    setKotaPerusahaan(response.data.kotaPerusahaan);
    setKabupatenPerusahaan(response.data.kabupatenPerusahaan);
    setProvinsiPerusahaan(response.data.provinsiPerusahaan);
    setTeleponPerusahaan(response.data.teleponPerusahaan);
    setDirekturUtama(response.data.direkturUtama);

    // COA
    setCoaKasKasir(response.data.coaKasKasir);
    setCoaHutangPembelianBarang(response.data.coaHutangPembelianBarang);
    setCoaPersediaan(response.data.coaPersediaan);
    setCoaPiutangPenjualan(response.data.coaPiutangPenjualan);
    setCoaPendapatanPenjualan(response.data.coaPendapatanPenjualan);
    setCoaHargaPokokPenjualan(response.data.coaHargaPokokPenjualan);
    setCoaPendapatanLainLain(response.data.coaPendapatanLainLain);
    setCoaRugiSelisihOpname(response.data.coaRugiSelisihOpname);
    setLabaRugiPeriodeBerjalan(response.data.labaRugiPeriodeBerjalan);
    setAccountPembalance(response.data.accountPembalance);

    // Group COA
    setKodeGroupPendapatan(response.data.kodeGroupPendapatan);
    setKodeGroupBiayaAtasPendapatan(response.data.kodeGroupBiayaAtasPendapatan);
    setKodeGroupPengeluaranOperasional(
      response.data.kodeGroupPengeluaranOperasional
    );
    setKodeGroupPendapatanLainLain(response.data.kodeGroupPendapatanLainLain);
    setKodeGroupBiayaLainLain(response.data.kodeGroupBiayaLainLain);
    setLoading(false);
  };

  const updateSetting = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      try {
        setLoading(true);
        try {
          setLoading(true);
          await postRequest(
            `/updateSetting/${id}`,
            {
              namaPerusahaan,
              alamatPerusahaan,
              kotaPerusahaan,
              kabupatenPerusahaan,
              provinsiPerusahaan,
              teleponPerusahaan,
              direkturUtama,

              // COA
              coaKasKasir,
              coaHutangPembelianBarang,
              coaPersediaan,
              coaPiutangPenjualan,
              coaPendapatanPenjualan,
              coaHargaPokokPenjualan,
              coaPendapatanLainLain,
              coaRugiSelisihOpname,
              labaRugiPeriodeBerjalan,
              accountPembalance,

              // Group COA
              kodeGroupPendapatan,
              kodeGroupBiayaAtasPendapatan,
              kodeGroupPengeluaranOperasional,
              kodeGroupPendapatanLainLain,
              kodeGroupBiayaLainLain,
            },
            navigate,
            dispatch
          );
          setLoading(false);
          e.preventDefault();
          handleLogout(dispatch, navigate);
        } catch (error) {
          alert(error.response.data.message);
        }
        setLoading(false);
      } catch (error) {
        alert(error);
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const textRightSmall = {
    textAlign: screenSize >= 650 && "right",
    fontSize: "14px",
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <Container>
      <h3>Utility</h3>
      <h5 style={{ fontWeight: 400 }}>Ubah Setting</h5>
      <hr />
      <Card>
        <Card.Header>Setting</Card.Header>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={updateSetting}>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Nama Perusahaan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={namaPerusahaan}
                          required
                          onChange={(e) => setNamaPerusahaan(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRightSmall}>
                        Alamat Perusahaan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={alamatPerusahaan}
                          required
                          onChange={(e) => setAlamatPerusahaan(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRightSmall}>
                        Kabupaten Perusahaan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={kabupatenPerusahaan}
                          required
                          onChange={(e) =>
                            setKabupatenPerusahaan(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRightSmall}>
                        Telepon Perusahaan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={teleponPerusahaan}
                          required
                          onChange={(e) => setTeleponPerusahaan(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Kota Perusahaan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={kotaPerusahaan}
                          required
                          onChange={(e) => setKotaPerusahaan(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRightSmall}>
                        Provinsi Perusahaan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={provinsiPerusahaan}
                          required
                          onChange={(e) =>
                            setProvinsiPerusahaan(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRightSmall}>
                        Direktur Utama :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={direkturUtama}
                          required
                          onChange={(e) => setDirekturUtama(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>

            <hr />
            <h5>COA</h5>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRightSmall}>
                        Coa Kas Kasir :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={coaKasKasir}
                          onChange={(e) => setCoaKasKasir(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRightSmall}>
                        Coa Hutang Pembelian Barang :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={coaHutangPembelianBarang}
                          onChange={(e) =>
                            setCoaHutangPembelianBarang(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRightSmall}>
                        Coa Persediaan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={coaPersediaan}
                          onChange={(e) => setCoaPersediaan(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRightSmall}>
                        Coa Piutang Penjualan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={coaPiutangPenjualan}
                          onChange={(e) =>
                            setCoaPiutangPenjualan(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRightSmall}>
                        Coa Pendapatan Penjualan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={coaPendapatanPenjualan}
                          onChange={(e) =>
                            setCoaPendapatanPenjualan(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRightSmall}>
                        Coa Harga Pokok Penjualan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={coaHargaPokokPenjualan}
                          onChange={(e) =>
                            setCoaHargaPokokPenjualan(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRightSmall}>
                        Coa Pendapatan Lain-Lain :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={coaPendapatanLainLain}
                          onChange={(e) =>
                            setCoaPendapatanLainLain(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRightSmall}>
                        Coa Biaya Lain-Lain :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={coaRugiSelisihOpname}
                          onChange={(e) =>
                            setCoaRugiSelisihOpname(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRightSmall}>
                        Laba Rugi Periode Berjalan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={labaRugiPeriodeBerjalan}
                          onChange={(e) =>
                            setLabaRugiPeriodeBerjalan(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRightSmall}>
                        Account Pembalance :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={accountPembalance}
                          onChange={(e) => setAccountPembalance(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>

            <hr />
            <h5>Group COA</h5>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRightSmall}>
                        Kode Group Pendapatan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={kodeGroupPendapatan}
                          onChange={(e) =>
                            setKodeGroupPendapatan(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRightSmall}>
                        Kode Group Biaya Atas Pendapatan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={kodeGroupBiayaAtasPendapatan}
                          onChange={(e) =>
                            setKodeGroupBiayaAtasPendapatan(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRightSmall}>
                        Kode Group Pengeluaran Operasional :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={kodeGroupPengeluaranOperasional}
                          onChange={(e) =>
                            setKodeGroupPengeluaranOperasional(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRightSmall}>
                        Kode Group Pendapatan Lain-Lain :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={kodeGroupPendapatanLainLain}
                          onChange={(e) =>
                            setKodeGroupPendapatanLainLain(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRightSmall}>
                        Kode Group Biaya Lain-Lain :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={kodeGroupBiayaLainLain}
                          onChange={(e) =>
                            setKodeGroupBiayaLainLain(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>

            <Box>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate("/setting")}
                sx={{ marginRight: 2 }}
              >
                {"< Kembali"}
              </Button>
              <Button
                variant="contained"
                startIcon={<EditIcon />}
                type="submit"
              >
                Edit
              </Button>
            </Box>
          </Form>
        </Card.Body>
      </Card>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default UbahSetting;

const alertBox = {
  width: "100%",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};
